/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Description/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import InputSmallLabel from 'DesignSystem/InputSmallLabel/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Description({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/TreatmentCaseCloser/Configuration/DefaultPaymentPlans/Rulesets/Content/Ruleset/DefaultPaymentPlans/DefaultPaymentPlan/Description",
  onChange
  
}) {
let defaultPaymentPlanDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'default_payment_plan',
path: 'description',
})
let defaultPaymentPlanDescriptionChangeData = fromData.useDataChange({ viewPath,
context: 'default_payment_plan',
path: 'description',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<InputSmallLabel
  viewPath={`${viewPath}/InputSmallLabel`}
 marginTop={dtSpaceS}
 marginRight={0}
 label="description"
 type="text"
 data="default_payment_plan.description"
 value={defaultPaymentPlanDescriptionValueData}
 onChange={defaultPaymentPlanDescriptionChangeData}
/>
{children}
</React.Fragment>)
}